import React, { useEffect, useState } from "react";
import { X, Save, UserPlus } from "lucide-react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);
const API = "https://apiftpsplit.ftpeople.pl";
const hdrs = { "Content-Type": "application/json", Authorization: secretKey };

const AddLead = (props) => {
  const [loading, setLoading] = useState(true);
  const [sources, setSources] = useState([]);

  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [phone, setPhone] = useState("");
  const [source, setSource] = useState("");
  const [company, setCompany] = useState("");
  const [idSource, setIdSource] = useState("");
  const [sourceLink, setSourceLink] = useState("");
  const [note, setNote] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/getLeadSources`, {
          method: "POST",
          headers: hdrs,
          body: "{}",
        });
        const data = await res.json();
        setSources((data || []).filter((s) => s.name !== "Polecenie"));
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    })();
  }, []);

  const validate = () => {
    if (!name.trim() || !phone.trim() || !mail.trim() || !source || !company) {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    console.log("asd");
    if (!validate()) return;
    try {
      await fetch(`${API}/addLead`, {
        method: "POST",
        headers: hdrs,
        body: JSON.stringify({
          name: name.trim(),
          phone: phone.trim(),
          mail: mail.trim(),
          source,
          note,
          company: company.trim(),
          idSource: idSource.trim(),
          linkSource: sourceLink.trim(),
          auto: "0",
          userId: props.user.id,
          userName: props.user.name,
        }),
      });
      MySwal.fire({ icon: "success", title: "Dodano", text: "lead" });
      props.close();
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) return <Loading />;

  return (
    <div
      className="sn-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) props.close();
      }}
    >
      <div className="sn-modal" style={{ maxWidth: 640 }}>
        {/* Header */}
        <div className="sn-header">
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <UserPlus size={18} />
            <h2 className="sn-title">Dodaj lead</h2>
          </div>
          <button className="ld-close" onClick={props.close}>
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="sn-body">
          <div className="scc-form-grid">
            <div className="rp-field">
              <label className="db-field-label">
                Imię i nazwisko <span className="scc-req">*</span>
              </label>
              <input
                type="text"
                className="db-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="rp-field">
              <label className="db-field-label">
                Adres e-mail <span className="scc-req">*</span>
              </label>
              <input
                type="email"
                className="db-input"
                value={mail}
                onChange={(e) => setMail(e.target.value)}
              />
            </div>
            <div className="rp-field">
              <label className="db-field-label">
                Numer telefonu <span className="scc-req">*</span>
              </label>
              <input
                type="tel"
                className="db-input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
            <div className="rp-field">
              <label className="db-field-label">
                Źródło <span className="scc-req">*</span>
              </label>
              <select
                className="db-input db-select"
                value={source}
                onChange={(e) => setSource(e.target.value)}
              >
                {!source && <option value="">Wybierz...</option>}
                {sources.map((s) => (
                  <option key={s.name} value={s.name}>
                    {s.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="rp-field">
              <label className="db-field-label">
                Dział <span className="scc-req">*</span>
              </label>
              <select
                className="db-input db-select"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              >
                {!company && <option value="">Wybierz...</option>}
                {(props.companies || []).map((c) => (
                  <option key={c.name} value={c.name}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="rp-field">
              <label className="db-field-label">ID źródło</label>
              <input
                type="text"
                className="db-input"
                value={idSource}
                onChange={(e) => setIdSource(e.target.value)}
              />
            </div>
            <div className="rp-field" style={{ gridColumn: "1 / -1" }}>
              <label className="db-field-label">Link — źródło</label>
              <input
                type="url"
                className="db-input"
                value={sourceLink}
                onChange={(e) => setSourceLink(e.target.value)}
                placeholder="https://..."
              />
            </div>
            <div className="rp-field" style={{ gridColumn: "1 / -1" }}>
              <label className="db-field-label">Uwagi — źródło</label>
              <textarea
                className="db-input ac-textarea"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Opcjonalne uwagi..."
              />
            </div>
          </div>

          <div className="scc-form-footer">
            <button className="lq-btn lq-btn--muted" onClick={props.close}>
              Anuluj
            </button>
            <button className="lq-btn lq-btn--success" onClick={handleSubmit}>
              <Save size={14} /> Dodaj lead
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLead;
